// frontend/src/pages/DeviceDetail.js
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Modal, Table, Spinner } from 'react-bootstrap';
import { IoArrowBack, IoVolumeMute, IoVolumeHigh } from 'react-icons/io5';
import { FaUserCircle, FaHistory } from 'react-icons/fa';
import api from '../api';
import { useAuth } from '../contexts/AuthContext';
import SanqiDeviceDetail from './SanqiDeviceDetail';

import StatusBar from '../components/StatusBar';
import SanqiStatusBoard from '../components/SanqiStatusBoard';
import HistoryModal from '../components/HistoryModal';
import '../components/HistoryModal.css'; // 导入液体玻璃效果样式

const DeviceDetail = () => {
  const { deviceId } = useParams();
  const navigate     = useNavigate();
  const { socket, user: currentUser } = useAuth();

  const [device, setDevice]                     = useState(null);
  const [currentScore, setCurrentScore]         = useState(0);
  const [remainingTurns, setRemainingTurns]     = useState(0);
  // const [turnCount, setTurnCount]           = useState(0); // 移除本轮转数独立状态
  const [comboCount, setComboCount]             = useState(0);

  // Moved styles and useEffect for CSS injection here
  const styles = {
    pageWrapper:    { position:'fixed', top:0,  left:0, right:0, bottom:0, background:'#000', color:'#fff', overflow:'visible', zIndex:0 },
    videoContainer: { position:'absolute', top:0, left:0, right:0, bottom:0, overflow:'hidden', zIndex:0 },
    iframe:         { width:'100%', height:'100%', border:0, objectFit:'cover' },
    videoFallback:  { width:'100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center', background:'#333', color:'#bbb', fontSize:'1.2rem' },
    
    unifiedInfoBarContainer: {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      zIndex: 1010,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '0',
      boxSizing: 'border-box',
    },
    unifiedInfoBar: {
      width: '100%',
      maxWidth: '1200px',
      minHeight: '40px',
      padding: '6px 10px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      alignItems: 'center',
      backgroundColor: 'rgba(10, 10, 15, 0.85)',
      backdropFilter: 'blur(5px)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
      gap: '8px 12px',
      boxSizing: 'border-box',
    },
    infoItemBase: {
      padding: '5px 8px',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      transition: 'background-color 0.3s ease',
    },
    statusBarDeviceIDSection: {
      padding: '5px 10px',
      // border: '1px solid rgba(255, 255, 255, 0.2)', // Covered by infoItemBase
      // borderRadius: '4px', // Covered by infoItemBase
      // backgroundColor: 'rgba(255, 255, 255, 0.05)', // Covered by infoItemBase
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    deviceIDText: {
      fontWeight: 'bold',
      fontSize: '0.93rem',
      color: '#E0E0E0',
    },
    userInfoItem: {
      fontSize: '0.86rem',
      color: '#D0D0D0',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
    },
    goldCoinIcon: {
      width: '14px',
      height: '14px',
      marginRight: '4px',
      color: '#FFD700',
    },
    silverCoinIcon: {
      width: '14px',
      height: '14px',
      marginRight: '4px',
      color: '#C0C0C0',
    },
    secondaryInfoItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    secondaryInfoLabel: {
      fontSize: '0.75rem',
      color: '#AAAAAA',
      marginBottom: '2px',
    },
    secondaryInfoValue: {
      fontSize: '0.86rem',
      color: '#E0E0E0',
      fontWeight: '500',
    },
    unifiedInfoButton: {
      padding: '6px 12px',
      fontSize: '0.9rem',
      color: '#FFFFFF',
      backgroundColor: 'rgba(0, 123, 255, 0.7)',
      cursor: 'pointer',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
    },
    btnBar: {
      position: 'fixed',
      bottom: 20,
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)',
      width: '80%',
      maxWidth: '1024px',
      padding: '15px 20px',
      height: '110px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      backdropFilter: 'blur(15px)',
      borderRadius: '20px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3), 0 0 20px rgba(59, 130, 246, 0.1)',
      pointerEvents: 'auto',
      zIndex: 1001,
    },
    ctrlBtn: {
      width: '85px',
      height: '85px',
      borderRadius: '15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
      margin: '0 10px',
      zIndex: 1002,
      border: '1px solid rgba(255, 255, 255, 0.15)',
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden',
    },
    ctrlBtnOverlay: {
      position:'absolute',
      top:0,
      left:0,
      right:0,
      bottom:0,
      borderRadius:'50%',
      zIndex:1,
      opacity:0.15,
      pointerEvents:'none',
      mixBlendMode:'normal'
    },
    btnIcon:        {
      width:'70%',
      height:'70%',
      objectFit:'contain',
      filter:'brightness(1.3) drop-shadow(0 0 6px rgba(255,255,255,0.8)) contrast(1.3)',
      position:'relative',
      zIndex:5,
      transition:'transform 0.3s ease, filter 0.3s ease',
      '&:hover': {
        transform: 'scale(1.1)',
        filter: 'brightness(1.4) drop-shadow(0 0 10px rgba(255,255,255,0.9)) contrast(1.3)'
      }
    },
    greenGrad:      'linear-gradient(135deg, rgba(5,255,227,0.3) 0%, rgba(3,125,113,0.15) 100%)',
    redGrad:        'linear-gradient(135deg, rgba(255,43,104,0.3) 0%, rgba(125,3,47,0.15) 100%)',
    yellowGrad:     'linear-gradient(135deg, rgba(255,217,0,0.3) 0%, rgba(125,101,3,0.15) 100%)',
    historyBtn:     {
      position: 'absolute',
      top: '10px',
      right: '15px',
      padding:'3px 12px',
      fontSize:'0.75rem',
      borderRadius: '20px',
      boxShadow: '0 5px 15px rgba(0,0,0,0.4), inset 0 1px 1px rgba(255,255,255,0.2)',
      backdropFilter: 'blur(5px)',
      border: '1px solid rgba(255,255,255,0.2)',
      background: 'rgba(0,80,150,0.35)',
      color: 'rgba(255,255,255,0.9)',
      letterSpacing: '0.5px',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      zIndex: 5
    },
  };

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    // Consolidating the global CSS and responsive styles for unifiedInfoBar
    styleSheet.innerText = `
      @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap');
      body { font-family: 'Orbitron', sans-serif !important; }

      /* 简洁的控制台悬停效果 */
      .ctrl-btn-hover:hover {
        transform: translateY(-3px) !important;
        border-color: rgba(59, 130, 246, 0.5) !important;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4), 0 0 15px rgba(59, 130, 246, 0.3) !important;
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(30, 41, 59, 0.9) 100%) !important;
      }

      .ctrl-btn-hover:hover img {
        filter: brightness(1.2) drop-shadow(0 0 10px rgba(59, 130, 246, 0.5)) !important;
      }

      .ctrl-btn-hover:active {
        transform: translateY(-1px) scale(0.98) !important;
        transition: all 0.1s ease !important;
      }

      /* Icon enhancement and button effects from original global CSS */
      .icon-enhanced {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.6)) brightness(1.3) contrast(1.2);
        transition: all 0.3s ease;
        z-index: 10;
        position: relative;
      }
      .dock-neon:hover:not([disabled]) .icon-enhanced {
        filter: drop-shadow(0 0 8px rgba(255, 255, 255, 1)) brightness(1.5) contrast(1.3);
        transform: scale(1.15);
      }
      .dock-neon {
        position: relative;
        overflow: visible;
        background: rgba(30, 30, 40, 0.5) !important;
      }
      .dock-neon::before { display: none; }
      .dock-neon:hover:not([disabled])::before { display: none; }
      .dock-neon:hover:not([disabled])::after {
        opacity: 1;
        box-shadow: inset 0 0 20px rgba(255, 255, 255, 0.3), 0 0 15px rgba(255, 255, 255, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.5);
      }
      .dock-neon .shine {
        position: absolute; top: 0; left: -100%; width: 100%; height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        z-index: 2; pointer-events: none; opacity: 0;
        animation: shine-through 4s ease-in-out infinite;
        animation-delay: calc(var(--btn-index, 0) * 1s);
      }
      .dock-neon::after {
        content: ''; position: absolute; top: 0; left: 0; right: 0; bottom: 0;
        border-radius: inherit;
        box-shadow: inset 0 0 15px rgba(255, 255, 255, 0.2), 0 0 8px rgba(255, 255, 255, 0.15);
        z-index: 1; pointer-events: none;
        border: 1px solid rgba(255, 255, 255, 0.35);
      }
      .glass-btn {
        background: rgba(70, 130, 180, 0.25) !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        backdrop-filter: blur(5px) !important;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3), inset 0 0 4px rgba(255, 255, 255, 0.2) !important;
        color: rgba(255, 255, 255, 0.9) !important;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
        transition: all 0.3s ease !important;
      }
      .glass-btn:hover:not([disabled]) {
        background: rgba(100, 160, 210, 0.35) !important;
        box-shadow: 0 4px 20px rgba(0, 150, 255, 0.4), inset 0 0 10px rgba(255, 255, 255, 0.3) !important;
        text-shadow: 0 0 5px rgba(255, 255, 255, 0.5) !important;
      }
      .glass-btn:active:not([disabled]) {
        transform: scale(0.95) !important;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2), inset 0 0 2px rgba(255, 255, 255, 0.1) !important;
      }
      .btnBar-appear { animation: fade-in-up 0.8s ease-out forwards; }
      .btn-label {
        transition: all 0.3s ease; opacity: 0.7; color: white; letter-spacing: 1px;
        text-transform: uppercase; font-size: 0.65rem !important; font-weight: bold !important;
        text-shadow: 0 2px 4px rgba(0,0,0,0.8) !important;
      }
      .dock-neon:hover:not([disabled]) .btn-label {
        opacity: 1; transform: translateY(-2px);
        animation: label-glow 2s ease-in-out infinite;
      }

      .fluorescent-text {
        text-shadow: 0 0 2px #fff, 0 0 4px #fff, 0 0 8px #39FF14, 0 0 12px #39FF14, 0 0 16px #39FF14;
      }

      /* Responsive styles for unifiedInfoBar */
      .unified-info-bar > div, .unified-info-bar > button { 
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        background-color: rgba(255, 255, 255, 0.03);
        padding: 5px 8px; 
      }
      .user-info-item {
        font-size: ${styles.userInfoItem.fontSize || '0.86rem'};
      }
      .unified-info-button {
        font-size: ${styles.unifiedInfoButton.fontSize || '0.9rem'};
        padding: ${styles.unifiedInfoButton.padding || '6px 12px'};
      }

      @media (max-width: 768px) {
        .unified-info-bar {
          padding: 5px 8px;
          gap: 6px 10px;
        }
        .device-id-text, .user-info-item, .secondary-info-label, .secondary-info-value, .unified-info-button {
          font-size: calc((${styles.deviceIDText.fontSize || '0.93rem'}) * 0.9);
        }
        .gold-coin-icon, .silver-coin-icon {
          width: 12px; height: 12px;
        }
        .unified-info-button {
          padding: 5px 10px;
        }
        .unified-info-bar > div, .unified-info-bar > button {
           padding: 4px 6px;
        }
      }
      @media (max-width: 480px) {
        .unified-info-bar {
          display: flex;
          flex-wrap: wrap;
          gap: 8px; /* Gap between items */
          align-items: stretch; /* Make items same height */
          padding: 6px;
        }

        /* 1. Hide Device ID */
        .unified-info-bar > .status-bar-device-id-section { 
          display: none !important; 
        }

        /* 2. Common style for all VISIBLE direct children (10 items) for 5-per-row layout */
        .unified-info-bar > div:not(.status-bar-device-id-section),
        .unified-info-bar > button {
          box-sizing: border-box;
          display: flex; 
          justify-content: center; 
          padding: 4px 6px; 
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 3px;
          background-color: rgba(255, 255, 255, 0.03);
          flex-basis: calc((100% - 4 * 8px) / 5); /* 5 items, 4 gaps of 8px */
          flex-grow: 1;   /* Allow to grow to fill basis */
          flex-shrink: 1; /* Allow to shrink */
          min-width: 0;   /* Allow shrinking below content size if necessary for flex-basis */
        }

        /* 3. Specifics for item types alignment and direction */
        .unified-info-bar > .user-info-item {
          align-items: center; 
          flex-direction: row; 
        }

        .unified-info-bar > .secondary-info-item {
          flex-direction: column; 
          align-items: center; 
          justify-content: center;
        }
        
        .unified-info-bar > .unified-info-button {
          align-items: center; 
          flex-direction: row; 
        }
        
        /* 4. Adjust font and icon sizes for compactness */
        
        /* User Info Items: Username, Points, Silver Coins */
        .unified-info-bar > .user-info-item > span {
          font-size: calc((${styles.userInfoItem.fontSize || '0.86rem'}) * 0.8);
          line-height: 1.15;
          white-space: normal; 
          text-align: center;
        }
        .unified-info-bar > .user-info-item svg { /* For FaUserCircle */
            width: 11px !important; 
            height: 11px !important;
            margin-right: 3px;
        }
        .unified-info-bar .gold-coin-icon, 
        .unified-info-bar .silver-coin-icon { /* For GiTwoCoins */
          width: 10px !important; 
          height: 10px !important; 
          margin-right: 3px;
        }

        /* Device Stats Items: Label and Value */
        .unified-info-bar > .secondary-info-item > .secondary-info-label { 
           font-size: calc((${styles.secondaryInfoLabel.fontSize || '0.75rem'}) * 0.8);
           margin-bottom: 1px;
           line-height: 1.15;
           white-space: normal; 
           text-align: center;
        }
        .unified-info-bar > .secondary-info-item > .secondary-info-value {
           font-size: calc((${styles.secondaryInfoValue.fontSize || '0.9rem'}) * 0.75);
           line-height: 1.15;
           white-space: normal; 
           text-align: center;
        }

        /* Action Buttons: Text and Icon */
        .unified-info-bar > .unified-info-button { /* This targets the button element for its direct text content */
          font-size: calc((${styles.unifiedInfoButton.fontSize || '0.9rem'}) * 0.8);
          gap: 3px; 
          line-height: 1.15;
          white-space: normal; 
          text-align: center; 
        }
        .unified-info-bar > .unified-info-button svg { /* For FaHistory, FaArrowLeft */
            width: 11px !important; 
            height: 11px !important;
        }
      }
    `;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Removed styles from dependency array as it causes re-renders, and the dynamic parts are now string literals or derived from initial styles object.
          // If styles object itself needs to be dynamic based on other state, this might need adjustment.

  // State & flip triggers
  const [showTipModal, setShowTipModal]         = useState(true);
  const [isRunning, setIsRunning]               = useState(false);
  const [pendingOperation, setPendingOperation] = useState(false);
  const [turnFlip, setTurnFlip]                 = useState(false);
  const [prizeFlip, setPrizeFlip]               = useState(false);

  const [showResultModal, setShowResultModal]   = useState(false);
  const [resultTitle, setResultTitle]           = useState('');
  const [resultMessage, setResultMessage]       = useState('');
  const [resultSuccess, setResultSuccess]       = useState(true);
  const [debitInfo, setDebitInfo]               = useState(null);

  const [showTurnDialog, setShowTurnDialog]     = useState(false);
  const turnOptions = [10, 20, 50, 100, 200];
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [panelOpen, setPanelOpen]               = useState(true);

  const goBack = () => navigate(-1);

  useEffect(() => {
    // 只在初始化时拉取一次设备详情，后续转数变化仅依赖 socket 推送
    const fetchData = async () => {
      try {
        const res = await api.get(`/api/devices/${deviceId}`);
        setDevice(res.data);
        setCurrentScore(res.data.lastScore || 0);
        if (res.data.currentRound) {
          setRemainingTurns(typeof res.data.currentRound.remainingTurns === 'number' ? res.data.currentRound.remainingTurns : 0);
          // setTurnCount(res.data.currentRound.turnCount || 0); // 移除
          setComboCount(res.data.currentRound.consecutivePrize || 0);
        }
      } catch (err) {
        console.error('获取设备详情失败:', err);
        alert(err.response?.data?.message || '获取设备详情失败');
        navigate(-1);
        return;
      }
      try {
        const runRes = await api.get(`/api/player/isRunning?deviceId=${deviceId}`);
        setIsRunning(!!runRes.data.running);
      } catch (err) {
        console.warn('获取运行状态失败:', err);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId, navigate]);

  // --- 确保 turnCount 只由 socket 事件维护，禁止其它 useEffect/setDevice 覆盖 ---
  // 不再有任何 useEffect 或 setDevice 影响 turnCount，除初始化和 socket 事件外
  useEffect(() => { if (device?.currentRound?.consecutivePrize != null) setPrizeFlip(true); }, [device?.currentRound?.consecutivePrize]);

  const [userPoints, setUserPoints] = useState(currentUser?.currentPoints || 0);
  const [silverCoins, setSilverCoins] = useState(currentUser?.silverCoins || 0);
  const [explosion, setExplosion] = useState(null); // { username, ts }

  // 顶部状态栏（钢珠机）移动端缩放：最高占 20% 视口高度 + 实时时钟
  const statusBaseRef = useRef(null);
  const [statusScale, setStatusScale] = useState(1);
  const [statusScaledH, setStatusScaledH] = useState();
  const [statusClock, setStatusClock] = useState('');

  const recalcStatusScale = React.useCallback(() => {
    const base = statusBaseRef.current;
    if (!base) return;
    const contentH = base.offsetHeight || 0;
    if (!contentH) return;
    const vw = window.innerWidth || document.documentElement.clientWidth || 375;
    const vh = window.innerHeight || document.documentElement.clientHeight || 667;
    const parent = base.parentElement;
    const parentW = parent?.clientWidth || vw;
    const isMobile = vw <= 768;
    const maxH = isMobile ? vh * 0.2 : contentH; // 移动端限制 20% 视口
    const scaleByH = Math.min(1, maxH / contentH);
    const scaleByW = Math.min(1, parentW / 1200);
    const s = Math.min(1, scaleByH, scaleByW);
    setStatusScale(s);
    setStatusScaledH(Math.round(contentH * s));
  }, []);

  useEffect(() => {
    // 实时时钟（每秒）
    const tick = () => setStatusClock(new Date().toLocaleTimeString('zh-CN', { hour12: false }));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    // 首次与窗口变化缩放
    recalcStatusScale();
    const onResize = () => recalcStatusScale();
    const onOrient = () => recalcStatusScale();
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onOrient);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onOrient);
    };
  }, [recalcStatusScale]);

  useEffect(() => {
    // 内容变化（数据/布局）时重算：包括历史格子数据长度、实时数值等
    recalcStatusScale();
    const el = statusBaseRef.current;
    if (!el || !('ResizeObserver' in window)) return;
    const ro = new ResizeObserver(() => recalcStatusScale());
    ro.observe(el);
    return () => ro.disconnect();
  }, [recalcStatusScale, userPoints, silverCoins, remainingTurns, device?.currentRound?.turnCount, currentScore, currentUser?.username, device?.deviceId]);

  // 稳定的回调函数，避免重新创建导致视频重载
  const handleVideoError = useCallback((error) => {
    console.error('视频播放错误:', error);
  }, []);

  const handleVideoLoad = useCallback(() => {
    console.log('视频加载成功');
  }, []);
  const playerRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [latency, setLatency] = useState(null);
  const [videoReady, setVideoReady] = useState(false);
  // 实时延迟测量
  useEffect(() => {
    let timer;
    const measureLatency = async () => {
      try {
        const start = Date.now();
        await api.get(`/api/player/isRunning?deviceId=${deviceId}`);
        setLatency(Date.now() - start);
      } catch (e) {
        console.warn('Latency test failed:', e);
      }
    };
    measureLatency();
    timer = setInterval(measureLatency, 5000);
    return () => clearInterval(timer);
  }, [deviceId]);
  const toggleMute = () => {
    const el = document.getElementById('player-container-id');
    let v = null;
    if (el && el.tagName && el.tagName.toLowerCase() === 'video') v = el;
    else if (el && el.querySelector) v = el.querySelector('video');
    if (!v) v = playerRef.current;
    const next = !(v?.muted ?? isMuted);
    try { if (v) v.muted = next; } catch (_) {}
    if (v && next === false) {
      try { v.volume = 1; } catch (_) {}
      try { const p = v.play?.(); if (p && p.catch) p.catch(() => {}); } catch (_) {}
    }
    setIsMuted(next);
  };

  // 3) socket events
  useEffect(() => {
    if (!socket) return;
    // 只用 setDevice 局部更新 currentRound.turnCount 和 remainingTurns，禁止其它地方 set turnCount/remainingTurns
    const hTurn = d => {
      if (d.deviceId === device?.deviceId) {
        setDevice(prev => {
          if (!prev) return prev;
          // immutable 更新，保留 device 其它字段
          const next = { ...prev, currentRound: { ...prev.currentRound } };
          next.currentRound.turnCount = d.turnCount;
          if (d.remainingTurns !== undefined) next.currentRound.remainingTurns = d.remainingTurns;
          return next;
        });
        if (d.remainingTurns !== undefined) setRemainingTurns(d.remainingTurns);
        // 新增：分数实时刷新
        if (typeof d.score === 'number') setCurrentScore(d.score);
      }
    };
    const hJack = j => {
      if (j.deviceId === device?.deviceId) {
        setDevice(prev => {
          if (!prev) return prev;
          const next = { ...prev, currentRound: { ...prev.currentRound } };
          next.isInJackpot = j.isInJackpot;
          if (j.currentRound?.consecutivePrize !== undefined) next.currentRound.consecutivePrize = j.currentRound.consecutivePrize;
          return next;
        });
      }
    };
    const hOp    = o => { if (o.category === 'startStop') setIsRunning(o.status === 'start'); };
    const hDebit = d => {
      console.log('[DeviceDetail] Received debitResult event:', d);
      setDebitInfo(d);
      setResultTitle('下分结果');
      setResultSuccess(true);
      setShowResultModal(true);
    };
    // 新增：监听积分和银币实时推送
    const hPoints = d => { if (typeof d.newPoints === 'number') setUserPoints(d.newPoints); };
    const hSilver = d => { if (typeof d.silverCoins === 'number') setSilverCoins(d.silverCoins); };
    // 新增：实时分数推送（兼容两种字段：newPoints / score）
    const hScore = payload => {
      if (!device) return;
      const matches = payload?.deviceId === device?.deviceId;
      if (!matches) return;
      const next = (typeof payload?.newPoints === 'number')
        ? payload.newPoints
        : (typeof payload?.score === 'number')
          ? payload.score
          : undefined;
      if (typeof next === 'number') setCurrentScore(next);
    };
    socket.on('turnUpdate',      hTurn);
    socket.on('jackpotUpdate',   hJack);
    socket.on('operationUpdate', hOp);
    socket.on('debitResult',     hDebit);
    socket.on('pointsUpdate',    hPoints);
  socket.on('scoreUpdate',     hScore);
    const hExplosion = data => {
      if (!device || data.deviceId !== device?._id) return;
      // 仅主玩家看到（当前用户是 currentHolder）
      const isPrimary = device?.currentHolder && (device.currentHolder === (currentUser?._id || currentUser?.id));
      if (!isPrimary) return;
      setExplosion({ username: data.secondaryUsername, ts: data.ts });
      setTimeout(()=>setExplosion(null),4000);
    };
    const hDevStatus = d => {
      if (!device) return;
      if (d.deviceId === device._id || d.tcpDeviceId === device.deviceId) {
        setDevice(prev => prev ? { ...prev, secondaryHolder: d.secondaryHolder ?? prev.secondaryHolder, secondaryWarmupRemaining: d.secondaryWarmupRemaining ?? prev.secondaryWarmupRemaining } : prev);
      }
    };
    socket.on('silverUpdate',    hSilver);
    socket.on('deviceStatusUpdate', hDevStatus);
    socket.on('doubleJoinExplosion', hExplosion);
    return () => {
      socket.off('turnUpdate', hTurn);
      socket.off('jackpotUpdate', hJack);
      socket.off('operationUpdate', hOp);
      socket.off('debitResult', hDebit);
      socket.off('pointsUpdate', hPoints);
  socket.off('scoreUpdate',  hScore);
      socket.off('silverUpdate', hSilver);
      socket.off('deviceStatusUpdate', hDevStatus);
      socket.off('doubleJoinExplosion', hExplosion);
    };
  }, [socket, device]);

  // Log state changes for real-time values
  useEffect(() => { console.log('remainingTurns →', remainingTurns); }, [remainingTurns]);
  useEffect(() => { console.log('turnCount →', device?.currentRound?.turnCount); }, [device?.currentRound?.turnCount]); // 日志用 device.currentRound.turnCount
  useEffect(() => { console.log('currentScore →', currentScore); }, [currentScore]);
  useEffect(() => { console.log('comboCount →', comboCount); }, [comboCount]);



  const start = async cnt => {
    setShowTurnDialog(false); setPendingOperation(true);
    try {
      await api.post(`/api/player/startStop?do=start`, { deviceId, turnCount: cnt });
      setIsRunning(true);
      setRemainingTurns(cnt);
    } catch (e) {
      alert(e.response?.data?.message || '开始失败');
    } finally {
      setPendingOperation(false);
    }
  };
  const stop = async () => {
    setPendingOperation(true);
    try {
      await api.post(`/api/player/startStop?do=stop`, { deviceId });
      setIsRunning(false);
    } catch (e) {
      alert(e.response?.data?.message || '停止失败');
    } finally {
      setPendingOperation(false);
    }
  };
  const debit = async () => {
    setPendingOperation(true);
    try {
      if (device?.type === 'sanqi') {
        await api.post(`/api/player/sanqi/debit`, { deviceId });
      } else {
        setCurrentScore(0);
        await api.post(`/api/player/debit`, { deviceId });
      }
    } catch (e) {
      setResultTitle('下分失败');
      setResultMessage(e.response?.data?.message || '请求失败');
      setResultSuccess(false);
      setShowResultModal(true);
    } finally {
      setPendingOperation(false);
    }
  };

  const hist = device?.histogramBars || [];
  // 计算“今日/前日”总转数，按每日10:00为边界
  const leftDailyTurns = React.useMemo(() => {
    if (!Array.isArray(hist) || hist.length === 0) return { today: 0, prev: 0 };
    const now = new Date();
    const boundary = new Date(now);
    boundary.setHours(10, 0, 0, 0); // 今日10:00
    // 若当前时间在当天10:00之前，则“今天”实际上指前一天10:00到今天10:00
    let startToday = new Date(boundary);
    let startPrev = new Date(boundary);
    if (now < boundary) {
      startToday = new Date(boundary.getTime() - 24 * 3600 * 1000);
      startPrev = new Date(boundary.getTime() - 2 * 24 * 3600 * 1000);
    } else {
      startPrev = new Date(boundary.getTime() - 24 * 3600 * 1000);
    }
    const endToday = now < boundary ? new Date(boundary) : now;
    const endPrev = startToday;

    let today = 0, prev = 0, winsToday = 0;
    for (const b of hist) {
      const ts = b.timestamp ? new Date(b.timestamp) : null;
      if (!ts) continue;
      const turns = Number(b.turnCount || 0) || 0;
      if (ts >= startToday && ts < endToday) {
        today += turns;
        winsToday += Number(b.consecutivePrize || 0) || 0;
      }
      else if (ts >= startPrev && ts < endPrev) prev += turns;
    }
    return { today, prev, winsToday };
  }, [hist]);

  // 生成近6天（按每日10:00为界）的每日总转数与连奖次数，按从最近一天到更早一天的顺序
  const leftDailySeries = React.useMemo(() => {
    if (!Array.isArray(hist) || hist.length === 0) return [];
    const res = [];
    const now = new Date();
    const baseBoundary = new Date(now);
    baseBoundary.setHours(10, 0, 0, 0);
    // 计算第0天（最近日段）的起止
    const dayStart = (offset) => {
      const d = new Date(baseBoundary);
      // 如果当前时间在 boundary 之前，则第0天起点应为昨天10:00
      const adjust = now < baseBoundary ? 1 : 0;
      d.setDate(d.getDate() - offset - adjust);
      return d;
    };
    const dayEnd = (offset) => dayStart(offset - 1);
    for (let i = 0; i < 6; i++) {
      const start = dayStart(i);
      const end = i === 0 ? (now < baseBoundary ? new Date(baseBoundary) : now) : dayStart(i - 1);
      let turns = 0, wins = 0;
      for (const b of hist) {
        const ts = b.timestamp ? new Date(b.timestamp) : null;
        if (!ts) continue;
        if (ts >= start && ts < end) {
          turns += Number(b.turnCount || 0) || 0;
          wins += Number(b.consecutivePrize || 0) || 0;
        }
      }
      res.push({ turns, wins });
    }
    return res;
  }, [hist]);

  if (device && (device.type === 'sanqi' || device.modelType === 'sanqi' || device.modelType === '三七机')) {
    return <SanqiDeviceDetail deviceId={deviceId} device={device} />;
  }

  // Debug render state
  console.log('DeviceDetail render state:', {
    remainingTurns,
    turnCount: device?.currentRound?.turnCount, // 修正为 device.currentRound.turnCount
    currentScore,
    comboCount,
    userPoints,
    silverCoins
  });

  // Main return statement for the component
  return (
    <div style={styles.pageWrapper}>
      <div style={{ /* Adjust based on actual info bar height */ width: '100%', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <div style={styles.videoContainer}>
          {device?.videoStreamAddress?.startsWith('webrtc://') ? (
            <div id="player-mount" style={{ width: '100%', height: '100%' }} />
          ) : device?.videoStreamAddress ? (
            <iframe
              title="video"
              src={device.videoStreamAddress}
              style={styles.iframe}
              allowFullScreen
            />
          ) : (
            <div style={styles.videoFallback}>暂无视频流地址</div>
          )}
          <TcPlayerInit
            streamUrl={device?.videoStreamAddress}
            onLoading={() => setVideoReady(false)}
            onReady={() => setVideoReady(true)}
          />
          {!videoReady && device?.videoStreamAddress?.startsWith('webrtc://') && (
            <div style={{ position:'absolute', inset:0, zIndex: 4, background:'#000', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <div style={{ textAlign:'center', color:'#fff' }}>
                <svg width="220" height="220" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg" style={{ display:'block', margin:'0 auto 18px' }}>
                  <defs>
                    {/* 原主品牌渐变（用于文字等） */}
                    <linearGradient id="to-grad" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#00D1FF"/>
                      <stop offset="100%" stopColor="#7C4DFF"/>
                    </linearGradient>
                    {/* 彩虹旋转渐变：用于外围发光效果 */}
                    <linearGradient id="to-rainbow" x1="0%" y1="0%" x2="100%" y2="0%" gradientUnits="userSpaceOnUse">
                      <stop offset="0%"   stopColor="#ff0040"/>
                      <stop offset="16%"  stopColor="#ff7a00"/>
                      <stop offset="33%"  stopColor="#ffd400"/>
                      <stop offset="50%"  stopColor="#2bff00"/>
                      <stop offset="66%"  stopColor="#00d5ff"/>
                      <stop offset="83%"  stopColor="#6a00ff"/>
                      <stop offset="100%" stopColor="#ff00a8"/>
                      <animateTransform attributeName="gradientTransform" attributeType="XML" type="rotate" from="0 110 110" to="360 110 110" dur="6s" repeatCount="indefinite"/>
                    </linearGradient>
                    <radialGradient id="to-glow" cx="50%" cy="50%" r="50%">
                      <stop offset="0%" stopColor="rgba(255,255,255,0.35)"/>
                      <stop offset="70%" stopColor="rgba(124,77,255,0.15)"/>
                      <stop offset="100%" stopColor="rgba(0,0,0,0)"/>
                    </radialGradient>
                    <filter id="to-neon" x="-50%" y="-50%" width="200%" height="200%">
                      <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
                      <feColorMatrix in="blur" type="matrix" values="0 0 0 0 0  0 0 0 0 0.6  0 0 0 0 1  0 0 0 1 0" result="glow"/>
                      <feBlend in="SourceGraphic" in2="glow" mode="screen"/>
                    </filter>
                  </defs>
                  <g style={{ transformOrigin:'110px 110px', animation:'to-spin 2.8s linear infinite' }}>
                    <circle cx="110" cy="110" r="92" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="8"/>
                    {/* 外围彩虹光环（主环） */}
                    <circle cx="110" cy="110" r="92" fill="none" stroke="url(#to-rainbow)" strokeWidth="8" strokeLinecap="round" strokeDasharray="560 220" className="to-dash" filter="url(#to-neon)"/>
                    {/* 外围彩虹光晕（柔光加粗） */}
                    <circle cx="110" cy="110" r="92" fill="none" stroke="url(#to-rainbow)" strokeWidth="14" opacity="0.25" filter="url(#to-neon)"/>
                    <circle cx="110" cy="110" r="82" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="1"/>
                    <circle cx="110" cy="110" r="105" fill="none" stroke="rgba(124,77,255,0.08)" strokeWidth="1"/>
                    <g style={{ transformOrigin:'110px 110px', animation:'to-spin 4.6s linear infinite' }}>
                      <circle cx="110" cy="14" r="4" fill="#00D1FF" filter="url(#to-neon)"/>
                    </g>
                    <g style={{ transformOrigin:'110px 110px', animation:'to-spin 6.2s linear infinite' }}>
                      <circle cx="110" cy="206" r="3.5" fill="#7C4DFF" filter="url(#to-neon)"/>
                    </g>
                    <g style={{ transformOrigin:'110px 110px', animation:'to-spin 3.2s linear infinite' }}>
                      <circle cx="200" cy="110" r="3" fill="#62F0FF" filter="url(#to-neon)"/>
                    </g>
                  </g>
                  <circle cx="110" cy="110" r="70" fill="url(#to-glow)" />
                  <g filter="url(#to-neon)">
                    <text x="110" y="118" textAnchor="middle" fontSize="28" fontWeight="900" letterSpacing="3" style={{ textTransform:'uppercase' }} fill="url(#to-grad)">THE ONE</text>
                  </g>
                </svg>
                <div style={{ fontSize:16, letterSpacing:1.5, opacity:0.92 }}>THE ONE 欢迎您 · 视频加载中 · 请稍后</div>
              </div>
              <style>{`@keyframes to-spin { to { transform: rotate(360deg); } } @keyframes to-dash-kf { 0% { stroke-dashoffset: 0; } 100% { stroke-dashoffset: -780; } } .to-dash { animation: to-dash-kf 2.2s linear infinite; }`}</style>
            </div>
          )}
        </div>

        {device && currentUser && (
      <div
            style={{
              margin: '0 auto',
              width: '100%',
              position: 'relative',
              zIndex: 1010,
              // 顶部贴紧：仅保留安全区，去掉额外 8px 留白
              marginTop: 'env(safe-area-inset-top, 0px)',
              paddingLeft: 'max(8px, env(safe-area-inset-left, 0px))',
              paddingRight: 'max(8px, env(safe-area-inset-right, 0px))',
        height: statusScaledH ?? 140
            }}
          >
            <div
              ref={statusBaseRef}
              style={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: `translateX(-50%) scale(${statusScale})`,
                transformOrigin: 'top center',
                width: 1200,
                pointerEvents: 'auto'
              }}
            >
              <SanqiStatusBoard
                deviceNo={device?.deviceId}
                username={currentUser.username}
                points={userPoints}
                silver={Number(silverCoins)}
                clock={statusClock}
                leftDailyTurns={leftDailyTurns}
                leftDailySeries={leftDailySeries}
                centerItems={[
                  { label: '剩余转数', value: Math.max(0, Number(remainingTurns || 0)) },
                  { label: '本轮转数', value: Number(device?.currentRound?.turnCount || 0) },
                  { label: '当前分数', value: Number(currentScore || 0).toFixed(1) }
                ]}
                gridData={{
                  mode: 'histogram',
                  rounds: hist.map(b => ({ totalTurns: b.turnCount, consecutiveWins: b.consecutivePrize, timestamp: b.timestamp })),
                  columns: 12,
                  rows: 8
                }}
              />
            </div>
            <div style={{
              position: 'absolute',
              top: '100%',
              right: '0',
              zIndex: 1011,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              gap: '8px'
            }}>
              {isMuted ? (
                <IoVolumeMute
                  size={28}
                  onClick={toggleMute}
                  title="取消静音"
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <IoVolumeHigh
                  size={28}
                  onClick={toggleMute}
                  title="静音"
                  style={{ cursor: 'pointer' }}
                />
              )}
              <IoArrowBack
                size={28}
                onClick={() => navigate(-1)}
                title="返回"
                style={{ cursor: 'pointer' }}
              />
              <div style={{ color: '#fff', fontSize: '0.9rem' }}>
                延迟: {latency !== null ? `${latency} ms` : '测试中...'}
              </div>
            </div>
          </div>
        )}

        <Modal show={showTipModal} dialogClassName="glass-modal" centered backdrop="static" keyboard={false} onHide={() => setShowTipModal(false)}>
          <Modal.Header closeButton><Modal.Title>温馨提示</Modal.Title></Modal.Header>
          <Modal.Body>
            <ul style={{ paddingLeft: '1.2em', marginBottom: 0 }}>
              <li>每人最多可占用 <strong>2</strong> 台设备</li>
              <li>设备 <strong>25 分钟</strong> 不运转自动弃台</li>
              <li>每转 2.8 积分 · 损耗 13% · 比例 6</li>
              <li>每日凌晨 5 点 P 系列机器复位重启</li>
            </ul>
          </Modal.Body>
          <Modal.Footer><Button className="glass-btn" onClick={() => setShowTipModal(false)}>我知道了</Button></Modal.Footer>
        </Modal>

        <Modal show={showTurnDialog} dialogClassName="glass-modal" centered onHide={() => setShowTurnDialog(false)}>
          <Modal.Header closeButton><Modal.Title>请选择转数</Modal.Title></Modal.Header>
          <Modal.Body style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            {turnOptions.map(opt => (
              <Button key={opt} variant="outline-primary" className="glass-btn" style={{ width: 80 }} onClick={() => start(opt)}>
                {opt} 转
              </Button>
            ))}
          </Modal.Body>
          <Modal.Footer><Button variant="secondary" className="glass-btn" onClick={() => setShowTurnDialog(false)}>取消</Button></Modal.Footer>
        </Modal>

        <Modal show={showResultModal} dialogClassName="glass-modal debit-modal" centered onHide={() => setShowResultModal(false)}>
          <Modal.Header closeButton><Modal.Title style={{ color: resultSuccess ? 'lime' : 'red' }}>{resultTitle}</Modal.Title></Modal.Header>
          <Modal.Body>
            {resultSuccess && debitInfo ? (
              <Table bordered size="sm" style={{ margin: '0 auto', width: 260, textAlign: 'center' }}>
                <tbody>
                  <tr><td>当前 FS</td><td>{debitInfo.fsRaw}</td></tr>
                  <tr><td>下分前积分</td><td>{debitInfo.beforePoints.toFixed(1)}</td></tr>
                  <tr><td>本次增加</td><td style={{ color: 'lime', fontWeight: 'bold' }}>{debitInfo.addedPoints.toFixed(1)}</td></tr>
                  <tr><td>现在积分</td><td>{debitInfo.afterPoints.toFixed(1)}</td></tr>
                </tbody>
              </Table>
            ) : (
              <p style={{ textAlign: 'center', fontSize: '1.1rem' }}>{resultMessage}</p>
            )}
          </Modal.Body>          <Modal.Footer style={{ justifyContent: 'center' }}>
            <Button variant={resultSuccess ? 'success' : 'danger'} className="glass-btn" onClick={() => setShowResultModal(false)} style={{ minWidth: 90 }}>确定</Button>
          </Modal.Footer>
        </Modal>

        <HistoryModal
          show={showHistoryModal}
          onHide={() => setShowHistoryModal(false)}
          deviceId={deviceId}
        />
      </div>
  {(device && !(device.type === 'sanqi' || device.modelType === 'sanqi' || device.modelType === '三七机')) && (
    <DoublePlayControls
      device={device}
      currentUser={currentUser}
      openTurnDialog={() => setShowTurnDialog(true)}
      onStop={stop}
      onDebit={debit}
      styles={styles}
    />
  )}
  {explosion && createPortal(<ExplosionOverlay username={explosion.username} />, document.body)}
    </div>
  );
};

export default DeviceDetail;

function ExplosionOverlay({ username }) {
  return (
    <div style={expStyles.overlay}>
      <div style={expStyles.core}>
        <div style={expStyles.glow}></div>
        <h1 style={expStyles.text}>{username} 乱入双打!</h1>
        {[...Array(28)].map((_,i)=>(<span key={i} style={{...expStyles.particle, ...particleDynamic(i)}} />))}
      </div>
    </div>
  );
}

const expStyles = {
  overlay:{position:'fixed',inset:0,zIndex:4000,pointerEvents:'none',display:'flex',alignItems:'center',justifyContent:'center',background:'radial-gradient(circle at center, rgba(255,255,255,0.05), rgba(0,0,0,0.85))',animation:'expFade 4s forwards'},
  core:{position:'relative',width:'65vmin',height:'65vmin',display:'flex',alignItems:'center',justifyContent:'center'},
  glow:{position:'absolute',inset:0,borderRadius:'50%',background:'radial-gradient(circle,#fff,#ff0 15%,rgba(255,120,0,0.4) 55%,transparent 70%)',filter:'blur(14px)',animation:'glowPulse 1.3s ease-in-out infinite'},
  text:{position:'absolute',color:'#fff',fontSize:'4.5vmin',fontWeight:900,letterSpacing:'6px',textShadow:'0 0 10px #fff,0 0 25px #ff0,0 0 45px #f60,0 0 70px #f00',animation:'textPop 0.9s ease-out'},
  particle:{position:'absolute',top:'50%',left:'50%',width:'10px',height:'10px',borderRadius:'50%',background:'linear-gradient(135deg,#fff,#ff0,#f60,#f00)',boxShadow:'0 0 8px #fff,0 0 14px #ff0,0 0 24px #f30',animation:'particle 1.25s linear forwards'}
};

function particleDynamic(i){
  const angle = (360/28)*i;
  const dist = 140 + (i%7)*24;
  const delay = (i%7)*0.045;
  return { transform:`rotate(${angle}deg)`, animation:`particle 1.25s ${delay}s cubic-bezier(.55,.1,.45,.95) forwards`, '--dist': `${dist}px`, '--angle': `${angle}deg` };
}

if (typeof document !== 'undefined' && !document.getElementById('explosion-anim-styles')) {
  const kf = document.createElement('style');
  kf.id = 'explosion-anim-styles';
  kf.innerHTML = `@keyframes particle {0%{transform:translate(-50%,-50%) scale(.3) rotate(var(--angle));opacity:1}60%{opacity:1}100%{transform:translate(calc(-50% + var(--dist)*cos(var(--angle))),calc(-50% + var(--dist)*sin(var(--angle)))) scale(.15);opacity:0}}
  @keyframes glowPulse {0%,100%{opacity:.7;transform:scale(1)}50%{opacity:1;transform:scale(1.18)}}
  @keyframes textPop {0%{transform:scale(.2) rotate(-25deg);opacity:0}55%{transform:scale(1.15)}100%{transform:scale(1) rotate(0);opacity:1}}
  @keyframes expFade {0%{opacity:1}82%{opacity:1}100%{opacity:0}}
  `;
  document.head.appendChild(kf);
}

// 跟单状态徽标样式（渐变+发光+脉冲）
if (typeof document !== 'undefined' && !document.getElementById('follow-badge-styles')) {
  const style = document.createElement('style');
  style.id = 'follow-badge-styles';
  style.innerHTML = `
  @keyframes badgeGradientShift {0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}
  @keyframes badgeGlowPulse {0%,100%{box-shadow:0 0 10px rgba(20,184,166,.35),0 0 22px rgba(56,189,248,.25)}50%{box-shadow:0 0 18px rgba(20,184,166,.55),0 0 36px rgba(56,189,248,.35)}}
  @keyframes badgePing {0%{transform:translate(-50%,-50%) scale(1);opacity:.8}80%{opacity:0}100%{transform:translate(-50%,-50%) scale(2.4);opacity:0}}
  .follow-badge{display:inline-flex;align-items:center;gap:8px;padding:6px 12px;border-radius:999px;color:#fff;font-weight:700;font-size:12px;letter-spacing:.5px;backdrop-filter:blur(4px);border:1px solid rgba(255,255,255,.18)}
  .follow-badge .dot{position:relative;width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.9);box-shadow:0 0 8px rgba(255,255,255,.7)}
  .follow-badge.available{background:linear-gradient(120deg,#22d3ee 0%,#34d399 45%,#60a5fa 100%);background-size:200% 200%;animation:badgeGradientShift 3.8s ease-in-out infinite,badgeGlowPulse 2.6s ease-in-out infinite}
  .follow-badge.available .dot::after{content:'';position:absolute;top:50%;left:50%;width:10px;height:10px;border-radius:999px;border:2px solid rgba(255,255,255,.7);transform:translate(-50%,-50%);animation:badgePing 1.8s cubic-bezier(.2,.8,.2,1) infinite}
  .follow-badge.joined{background:linear-gradient(135deg,#22c55e,#16a34a);box-shadow:0 0 12px rgba(34,197,94,.35),0 0 28px rgba(22,163,74,.3)}
  .follow-badge.none{background:linear-gradient(135deg,#6b7280,#4b5563);opacity:.9}
  `;
  document.head.appendChild(style);
}

// 双打控制台组件
function DoublePlayControls({ device, currentUser, openTurnDialog, onStop, onDebit, styles }) {
  // 容错：若未传 styles，提供最小默认结构避免报错
  if (!styles) {
    styles = { btnBar: { display:'flex' }, ctrlBtn: { width:80, height:80 } };
  }
  const [doubleStatus, setDoubleStatus] = React.useState(null);
  const toId = (v) => {
    if (!v) return null;
    if (typeof v === 'string') return v;
    if (typeof v === 'object') {
      if (v._id) return String(v._id);
      if (v.id) return String(v.id);
      if (v.toString) return String(v.toString());
    }
    return null;
  };
  const userId = currentUser?._id || currentUser?.id;
  const currentHolderId = toId(device?.currentHolder);
  const secondaryHolderId = toId(device?.secondaryHolder);
  const isPrimary = !!userId && !!currentHolderId && currentHolderId === String(userId);
  const isSecondary = !!userId && !!secondaryHolderId && secondaryHolderId === String(userId) && !isPrimary;
  const warmup = device?.secondaryWarmupRemaining ?? 0;

  const fetchStatus = React.useCallback(async () => {
    if (!device?._id) return;
    try {
      const res = await api.get(`/api/player/double/status?deviceId=${device._id}`);
      setDoubleStatus(res.data.data);
    } catch (e) { /* ignore */ }
  }, [device?._id]);

  React.useEffect(() => { fetchStatus(); }, [fetchStatus]);

  // 加入/退出跟单（副玩家开关）
  const toggleFollow = async () => {
    if (!device?._id) return;
    try {
      if (isSecondary) {
        await api.post('/api/player/double/leave', { deviceId: device._id });
      } else {
        await api.post('/api/player/double/join', { deviceId: device._id });
      }
      await fetchStatus();
    } catch (e) { /* ignore */ }
  };

  // 控制按钮逻辑:
  // 主玩家: 启动 + 停止 + 下分 + (若无副玩家且有人占用自己)显示“邀请副玩家”按钮替换为加入按钮在别的界面处理
  // 副玩家: 只有“启动(选择转数)” + 退出双打按钮
  // 其他用户: 只有启动按钮 (加入副玩家按钮如果已有主玩家且无副玩家)

  const hasPrimary = !!currentHolderId;
  const hasSecondary = !!secondaryHolderId;
  const showJoinDouble = !isPrimary && !isSecondary && hasPrimary && !hasSecondary;
  const showFollowToggle = isSecondary || showJoinDouble; // 显示单一“跟单”按钮（未加入=开始，已加入=停止）

  // 跟单状态徽标（非主玩家显示）
  const renderFollowBadge = () => {
    if (isPrimary) return null;
    const state = isSecondary ? 'joined' : (showJoinDouble ? 'available' : 'none');
    const text  = state === 'joined' ? '跟单中' : state === 'available' ? '可跟单' : '未跟单';
    return (
      <div className={`follow-badge ${state}`} style={{ alignSelf:'flex-start', marginRight:12 }}>
        <span className="dot"/>
        <span>{text}</span>
      </div>
    );
  };

  return (
    <div style={styles.btnBar} className="liquid-glass-console">
      {renderFollowBadge()}
  {/* 启动按钮：仅空闲或主玩家可见；他人占用时隐藏，改用跟单 */}
  {(!hasPrimary || isPrimary) && (
        <div
          className="ctrl-btn-hover liquid-glass-btn"
          style={{...styles.ctrlBtn}}
          onClick={() => { openTurnDialog(); }}
          title={'选择转数'}
        >
          <img src={`${process.env.PUBLIC_URL}/assets/control-panel/btn1.png`} alt="启动" style={{ width:'100%',height:'100%',objectFit:'contain',pointerEvents:'auto',transition:'all .3s' }} />
        </div>
      )}
      {/* 主玩家专有: 停止 & 下分 */}
      {isPrimary && (
        <>
          <div className="ctrl-btn-hover liquid-glass-btn" style={styles.ctrlBtn} onClick={onStop} title="停止设备">
            <img src={`${process.env.PUBLIC_URL}/assets/control-panel/btn2.png`} alt="停止" style={{ width:'100%',height:'100%',objectFit:'contain',pointerEvents:'auto',transition:'all .3s' }} />
          </div>
          <div className="ctrl-btn-hover liquid-glass-btn" style={styles.ctrlBtn} onClick={onDebit} title="下分">
            <img src={`${process.env.PUBLIC_URL}/assets/control-panel/btn3.png`} alt="下分" style={{ width:'100%',height:'100%',objectFit:'contain',pointerEvents:'auto',transition:'all .3s' }} />
          </div>
        </>
      )}
      {/* 单一“跟单”按钮：副玩家仅此一个。未加入=开始，已加入=停止 */}
      {showFollowToggle && (
        <div
          className="ctrl-btn-hover liquid-glass-btn"
          style={styles.ctrlBtn}
          onClick={toggleFollow}
          title={isSecondary ? '跟单停止' : '跟单开始'}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/control-panel/btn2.png`}
            alt={isSecondary ? '跟单停止' : '跟单开始'}
            style={{ width:'100%',height:'100%',objectFit:'contain',filter: isSecondary ? 'hue-rotate(90deg)' : 'hue-rotate(200deg)',pointerEvents:'auto',transition:'all .3s' }}
          />
        </div>
      )}
      {/* 提示 & 等待期显示 */}
      {showFollowToggle && !isSecondary && (
        <div style={{ alignSelf:'center', color:'#fff', fontSize:12, marginLeft:12, opacity:0.75 }}>按“跟单开始”，与主玩家同步扣费</div>
      )}
      {isSecondary && warmup>0 && (
        <div style={{ alignSelf:'center', color:'#ffeb3b', fontSize:12, marginLeft:12, fontWeight:600 }}>等待期：{warmup} 转后开始同步扣费</div>
      )}
    </div>
  );
}

// 腾讯云 WebRTC 播放器初始化组件
function TcPlayerInit({ streamUrl, onLoading, onReady }) {
  const shouldInit = !!streamUrl && streamUrl.startsWith('webrtc://');
  const loadCSS = (href) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`link[href="${href}"]`)) { resolve(); return; }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  useEffect(() => {
  if (!shouldInit) return;
    let player;
    let destroyed = false;
    let reconnectTimer = null;
    let watchdogTimer = null;
  let startupTimeout = null;
    let backoff = 1200; // 初始重连间隔
    let lastTime = 0;
    let stalledTicks = 0;
  let userMutedPref = true;
  let reportedReady = false;
  const markLoading = () => { try { onLoading && onLoading(); } catch(_){} };
  const markReady = () => { if (!reportedReady) { reportedReady = true; try { onReady && onReady(); } catch(_){} } };

    const clearTimers = () => {
      if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
      if (watchdogTimer) { clearInterval(watchdogTimer); watchdogTimer = null; }
      if (startupTimeout) { clearTimeout(startupTimeout); startupTimeout = null; }
    };
    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) { resolve(); return; }
        const s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.body.appendChild(s);
      });
    const getVideoEl = () => {
      const host = document.getElementById('player-container-id');
      if (host) {
        if (host.tagName && host.tagName.toLowerCase() === 'video') return host;
        const inner = host.querySelector ? host.querySelector('video') : null;
        if (inner) return inner;
      }
      const mount = document.getElementById('player-mount');
      if (mount && mount.querySelector) return mount.querySelector('video');
      return null;
    };
    const tryPlay = (preferMutedFallback = true) => {
      const v = getVideoEl();
      if (!v) return;
      try {
        const p = v.play?.();
        if (p && typeof p.catch === 'function') {
          p.catch(() => {
            if (preferMutedFallback) {
              v.muted = true;
              userMutedPref = true;
              try {
                const p2 = v.play?.();
                if (p2 && typeof p2.catch === 'function') p2.catch(() => {});
              } catch (_) {}
            }
          });
        }
      } catch (_) {}
    };
    const ensurePlay = () => {
      const v = getVideoEl();
      if (!v) return;
      if (typeof userMutedPref === 'boolean') v.muted = userMutedPref;
      tryPlay(true);
    };

  const startWatchdog = () => {
      clearTimers();
      watchdogTimer = setInterval(() => {
        if (destroyed) return;
    const v = getVideoEl();
        if (!v) return;
        const t = v.currentTime || 0;
        const advanced = t > lastTime + 0.05;
        const readyOk = (v.readyState || 0) >= 2;
        if (!advanced || !readyOk) stalledTicks += 1; else { stalledTicks = 0; markReady(); }
        lastTime = t;
        if (stalledTicks >= 3) {
          console.warn('[TCPlayer][steel] stalled detected, reconnecting...');
          reconnect('watchdog-stalled');
        }
      }, 2000);
    };

    const destroyPlayer = () => {
      try {
        const v = getVideoEl();
        if (v && typeof v.muted === 'boolean') userMutedPref = v.muted;
      } catch (_) {}
      try { player?.pause?.(); } catch (_) {}
      try { player?.destroy?.(); } catch (_) {}
      player = null;
      try {
        const host = document.getElementById('player-container-id');
        if (host && host.parentNode) host.parentNode.removeChild(host);
      } catch (_) {}
    };

    const reconnect = (reason) => {
      if (destroyed) return;
      clearTimers();
      destroyPlayer();
      reportedReady = false;
      markLoading();
      const delay = Math.min(backoff, 15000);
      console.warn('[TCPlayer][steel] reconnect due to:', reason, 'in', delay, 'ms');
      reconnectTimer = setTimeout(() => {
        if (destroyed) return;
        backoff = Math.min(Math.floor(backoff * 1.6), 20000);
        initPlayer();
      }, delay);
    };

    const bindPlayerEvents = () => {
      try {
        player?.on?.('error', (e) => {
          console.warn('[TCPlayer][steel] error event', e);
          reconnect('error');
        });
        player?.on?.('waiting', () => {});
  player?.on?.('play', () => { backoff = 1200; ensurePlay(); markReady(); if (startupTimeout) { clearTimeout(startupTimeout); startupTimeout = null; } });
  player?.on?.('loadeddata', () => { ensurePlay(); const v = getVideoEl(); if (v && v.readyState >= 2) { markReady(); if (startupTimeout) { clearTimeout(startupTimeout); startupTimeout = null; } } });
        player?.on?.('ended', () => reconnect('ended'));
      } catch (e) {}
    };

  const initPlayer = async () => {
      try {
        const mountEl = document.getElementById('player-mount');
        if (!mountEl || destroyed) return;
    markLoading();
        let host = document.getElementById('player-container-id');
        if (!host) {
          host = document.createElement('video');
          host.id = 'player-container-id';
          host.className = 'tcplayer';
          host.setAttribute('preload', 'auto');
          host.setAttribute('playsinline', 'true');
          host.setAttribute('webkit-playsinline', 'true');
          host.style.width = '100%';
          host.style.height = '100%';
          host.style.objectFit = 'cover';
          host.style.background = '#000';
          // 允许初次点击触发播放（满足部分端要求“直接点击视频”）
          host.style.pointerEvents = 'auto';
          mountEl.appendChild(host);
        }
        await loadCSS('https://web.sdk.qcloud.com/player/tcplayer/release/v4.9.1/tcplayer.min.css');
        try {
          await loadScript('https://video.sdk.qcloudecdn.com/web/TXLivePlayer-1.3.2.min.js');
        } catch (_) {
          await loadScript('https://web.sdk.qcloud.com/player/tcplayer/release/TXLivePlayer-1.3.2.min.js');
        }
        await loadScript('https://web.sdk.qcloud.com/player/tcplayer/release/v4.9.1/tcplayer.v4.9.1.min.js');
        if (destroyed || !window.TCPlayer) return;
        player = new window.TCPlayer('player-container-id', {
          sources: [streamUrl],
          autoplay: true,
          controls: false,
          live: true,
          playsinline: true
        });
  const v = getVideoEl();
  if (v && typeof userMutedPref === 'boolean') v.muted = userMutedPref;
  startupTimeout = setTimeout(() => {
    if (!destroyed && !reportedReady) reconnect('startup-timeout');
  }, 8000);
  bindPlayerEvents();
  ensurePlay();
        startWatchdog();
      } catch (e) {
        console.warn('[TCPlayer][steel] init failed, schedule reconnect', e);
        reconnect('init-failed');
      }
    };

  const onVisibility = () => {
      if (document.visibilityState === 'visible') {
    const v = getVideoEl();
        if (!v || v.readyState < 2) reconnect('visibility-visible'); else ensurePlay();
      }
    };
    const onOnline = () => reconnect('online');
    const onClickPlay = () => ensurePlay();

    initPlayer();
    const onUR = (e) => {
      const reason = e?.reason;
      const msg = (reason && (reason.message || reason.toString?.())) || '';
      const name = reason && reason.name;
      if (name === 'AbortError' || (typeof msg === 'string' && msg.includes('The operation was aborted'))) {
        e.preventDefault();
      }
    };
    window.addEventListener('unhandledrejection', onUR);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('online', onOnline);
    window.addEventListener('focus', onVisibility);
    window.addEventListener('click', onClickPlay, { once: true, capture: true });

    return () => {
      destroyed = true;
      clearTimers();
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('online', onOnline);
      window.removeEventListener('focus', onVisibility);
  window.removeEventListener('click', onClickPlay, true);
  window.removeEventListener('unhandledrejection', onUR);
      try { player?.destroy?.(); } catch (_) {}
    };
  }, [streamUrl, shouldInit]);
  return null;
}

// --- Image generation for futuristic control panel button variations ---
// image_gen.text2im({
//   "prompt": "Futuristic UI bottom control panel with three buttons labeled '启动', '停止', '下分' in Chinese. Variation style: 1) sharp neon gradient edges, 2) glassy soft glow finish, 3) metallic chrome with laser accents, 4) minimal outline with light trails. Dark tech background.",
//   "size": "1024x512",
//   "n": 4
// });
